<div class="selectCountry-item">
  <div class="selectCountry-flag" [style.background-image]="url"></div>
  <span class="selectCountry-country">{{ countryName | translate }}</span>
  <span *ngIf="showCountryCode" class="selectCountry-code">+ {{ countryCode }}</span>
</div>
